import { render, staticRenderFns } from "./FormFieldsNameEmail.vue?vue&type=template&id=5880bd42&"
import script from "./FormFieldsNameEmail.vue?vue&type=script&lang=js&"
export * from "./FormFieldsNameEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports